import { useQuery } from '@tanstack/react-query'
import { analyticsAPI } from '../api/analytics'

export type StatsPeriod = 'week' | 'month' | 'year'

export const useExpediteurStats = (period: StatsPeriod = 'month') => {
  return useQuery({
    queryKey: ['expediteur-stats', period],
    queryFn: () => analyticsAPI.getExpediteurStats(period),
    staleTime: 5 * 60 * 1000,
    retry: 2,
  })
}
